import get from 'lodash.get';

import { logError } from 'middleware/logger';

export const getThemeValue = (tokenName: string, theme: Object): number | string | undefined => {
  if (tokenName.includes('.')) {
    throw new Error(`Delimiter \`.\` is forbidden in theme getter arguments. Use \`${tokenName.replaceAll('.', '/')}\` instead`);
  }

  const value = get(theme, tokenName.replaceAll('/', '.'));

  if (value === null || value === undefined) {
    logError(`\`${tokenName}\` is not defined in the \`theme\` object`);
    return undefined;
  }

  if (typeof value !== 'number' && typeof value !== 'string') {
    throw new Error(`\`${tokenName}\` is of type \`${typeof value}\` and not \`number|string\``);
  }

  if (typeof value === 'string' && value.match(/\[.*\]/)) {
    const matchedValue = value.match(/\[(.*)\]/);

    if (matchedValue === null || matchedValue[1] === undefined) {
      logError(`\`${tokenName}\` is not defined in the \`theme\` object`);
      return undefined;
    }

    return getThemeValue(matchedValue[1], theme);
  }

  return value;
};

export const themed =
  (tokenName: string) =>
  ({ theme }: { theme: Object }) =>
    getThemeValue(tokenName, theme);
